export const maxWidthSm = 767; // px
export const minWidthLg = 768; // px
export const minHeightLg = 450; // px

export const CAPTIONS_ENABLED_KEY = 'storage_captions_enabled';
export const TTS_SETTINGS_KEY = 'storage_tts_settings';

export const NESTED_MENU_ITEM_PADDING = 20; // px
export const MS_IN_S = 1000;

